import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import Paragraph from '@marvelapp/marvel-ui/paragraph';

import Tick from 'marketing-website/components/icons/Tick';

import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck.js';

import styles from './style/general.module.css';

export default function TickedCopy({
  children,
  isCentered,
  size,
  shouldShowBlackTick,
}) {
  const containerClass = cx(styles.container, {
    'alignItems-center': isCentered,
    'fill-black': shouldShowBlackTick,
  });
  return (
    <div className={containerClass}>
      <div className={styles.tick}>
        <Tick />
      </div>
      <Paragraph size={size}>{children}</Paragraph>
    </div>
  );
}

TickedCopy.propTypes = {
  shouldShowBlackTick: PropTypes.bool,
  children: propTypeEmptyString,
  isCentered: PropTypes.bool,
  size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
};

TickedCopy.defaultProps = {
  isCentered: false,
  size: 'm',
  shouldShowBlackTick: false,
};



// WEBPACK FOOTER //
// ./src/components/modules/TickedCopy/index.js